import React from 'react';
import ButtonBase from './ButtonBase';
import classNames from 'classnames';

function ButtonPrimary(props) {
    let buttonClasses = classNames('btn-primary', props.className);

    return <ButtonBase {...props} className={buttonClasses} />;
}

ButtonPrimary.propTypes = {
    ...ButtonBase.propTypes
};

ButtonPrimary.defaultProps = {
    ...ButtonBase.defaultProps
};

export default ButtonPrimary;
